var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntroduce1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "object-fill",
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_290_2754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4688 25.3812C10.4688 17.0969 17.1845 10.3812 25.4688 10.3812H55.4688C63.753 10.3812 70.4688 17.0969 70.4688 25.3812V70.3812H25.4688C17.1845 70.3812 10.4688 63.6654 10.4688 55.3812V25.3812Z",
    fill: "#FFD35B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9074 39.7145H39.8008C41.3921 39.7145 42.9182 40.3466 44.0434 41.4719C45.1686 42.5971 45.8008 44.1232 45.8008 45.7145H36.4661L36.4674 47.0478H47.1341V45.7145C47.1299 44.2958 46.72 42.9079 45.9528 41.7145H49.8008C51.0611 41.7142 52.2958 42.0711 53.3615 42.7439C54.4272 43.4167 55.2804 44.3778 55.8221 45.5158C52.6688 49.6772 47.5634 52.3812 41.8008 52.3812C38.1194 52.3812 35.0008 51.5945 32.4674 50.2145V37.8092C34.0896 38.0415 35.6214 38.6989 36.9074 39.7145ZM31.1341 49.7145C31.1341 50.0681 30.9936 50.4073 30.7436 50.6573C30.4935 50.9074 30.1544 51.0478 29.8008 51.0478H27.1341C26.7805 51.0478 26.4414 50.9074 26.1913 50.6573C25.9413 50.4073 25.8008 50.0681 25.8008 49.7145V37.7145C25.8008 37.3609 25.9413 37.0217 26.1913 36.7717C26.4414 36.5216 26.7805 36.3812 27.1341 36.3812H29.8008C30.1544 36.3812 30.4935 36.5216 30.7436 36.7717C30.9936 37.0217 31.1341 37.3609 31.1341 37.7145V49.7145ZM48.4674 31.0478C49.5283 31.0478 50.5457 31.4693 51.2959 32.2194C52.046 32.9696 52.4674 33.987 52.4674 35.0478C52.4674 36.1087 52.046 37.1261 51.2959 37.8763C50.5457 38.6264 49.5283 39.0478 48.4674 39.0478C47.4066 39.0478 46.3892 38.6264 45.639 37.8763C44.8889 37.1261 44.4674 36.1087 44.4674 35.0478C44.4674 33.987 44.8889 32.9696 45.639 32.2194C46.3892 31.4693 47.4066 31.0478 48.4674 31.0478ZM39.1341 27.0478C40.195 27.0478 41.2124 27.4693 41.9625 28.2194C42.7127 28.9696 43.1341 29.987 43.1341 31.0478C43.1341 32.1087 42.7127 33.1261 41.9625 33.8763C41.2124 34.6264 40.195 35.0478 39.1341 35.0478C38.0732 35.0478 37.0558 34.6264 36.3057 33.8763C35.5555 33.1261 35.1341 32.1087 35.1341 31.0478C35.1341 29.987 35.5555 28.9696 36.3057 28.2194C37.0558 27.4693 38.0732 27.0478 39.1341 27.0478Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_290_2754",
    x: 0.46875,
    y: 0.381165,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.76 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_290_2754"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_290_2754",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroduce1);
export default __webpack_public_path__ + "static/media/introduce1.77eb76218be6de3e75f5dab1bbd5ba9a.svg";
export { ForwardRef as ReactComponent };